// src/features/claim/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import ClaimRequests from './pages/requests/Requests';
import ClaimRequestsForm from './pages/requests/RequestsForm';
import Detail from './pages/requests/Detail';
import ApproveRejectClaimPage from './pages/requests/ApproveRejectClaim';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const claimRoute = createRoute({
 getParentRoute: () => rootRoute,
   path: '/claim',
});


export const claimRequestsPageRoute = createRoute({
    getParentRoute: () => claimRoute,
    path: '/requests',
    component: ClaimRequests,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CLAIM.SEARCH || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const claimRequestsFormRoute = createRoute({
    getParentRoute: () => claimRoute,
    path: 'requests/form',
    component: ClaimRequestsForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CLAIM.SAVE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const claimDetailPageRoute = createRoute({
    getParentRoute: () => claimRoute,
    path: '/requests/detail',
    component: Detail,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CLAIM.DETAIL || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const approveRejectClaimRoute = createRoute({
    getParentRoute: () => claimRoute,
    path: '/requests/approve-reject',
    component: ApproveRejectClaimPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CLAIM.APPROVED_STATUS || "")) && !hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CLAIM.REJECTED_STATUS || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const claimRouteRoutes = [
    claimRoute,
    claimRequestsPageRoute,
    claimRequestsFormRoute,
    claimDetailPageRoute,
    approveRejectClaimRoute
];